import { TNameValidationResponse } from '@commenda/api';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Icons,
  LoadingIndicator,
} from '@commenda/kakashi';

export const NameCheckerModal = ({
  isOpen,
  onClose,
  isLoading,
  onContinue,
  results,
}: {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  onContinue: () => void;
  results: TNameValidationResponse[];
}) => {
  const getIcon = (status: TNameValidationResponse['status']) => {
    if (status === 'pass')
      return <Icons.CheckCircle className="size-4 text-text-success" />;
    if (status === 'review')
      return <Icons.InfoCircle className="size-4 text-text-warning" />;
    if (status === 'fail')
      return <Icons.XCircle className="size-4 text-text-error" />;
    return null;
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent preventCloseOnOutsideClick>
        {isLoading ? (
          <div className="flex flex-col gap-4 justify-center items-center h-[300px]">
            <LoadingIndicator />
            <span className="px-10 text-center">
              Please wait while we check if the name is likely to be accepted or
              not.
            </span>
          </div>
        ) : (
          <div>
            <DialogHeader>
              <DialogTitle>Name validation results</DialogTitle>
            </DialogHeader>
            <div className="p-6 flex flex-col gap-5">
              {results.map((result) => (
                <div className="flex flex-col gap-2 p-4 border border-border-primary rounded-md">
                  <h4>{result.normalizedName}</h4>
                  <div className="flex flex-col gap-2">
                    {result.issues.map((issue) => (
                      <div className="flex gap-2 items-start">
                        <div className="mt-0.5">{getIcon(result.status)}</div>
                        <span className="txt-small-regular">
                          {issue.detail}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="secondary" onClick={onClose} disabled={isLoading}>
            Modify
          </Button>
          <Button onClick={onContinue} disabled={isLoading}>
            Proceed
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
